import {
  FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
  FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS_2,
  SAVE_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
  DELETE_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
  FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS,
  FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_2,
  SAVE_CLIENT_INVENTORY_CHECK_QUESTIONS,
  DELETE_CLIENT_INVENTORY_CHECK_QUESTIONS,
  FETCH_CLIENT_INVENTORY_FORM_RESPONSES,
  FETCH_CLIENT_INVENTORY_FORM_RESPONSES_2,
  SAVE_CLIENT_INVENTORY_FORM_RESPONSES,
  DELETE_CLIENT_INVENTORY_FORM_RESPONSES,
  FETCH_CLIENT_INVENTORY_CHECK_ANSWERS,
  FETCH_CLIENT_INVENTORY_CHECK_ANSWERS_2,
  SAVE_CLIENT_INVENTORY_CHECK_ANSWERS,
  DELETE_CLIENT_INVENTORY_CHECK_ANSWERS,
  FETCH_CLIENT_INVENTORY_CHECK_PICTURES,
  FETCH_CLIENT_INVENTORY_CHECK_PICTURES_2,
  SAVE_CLIENT_INVENTORY_CHECK_PICTURES,
  DELETE_CLIENT_INVENTORY_CHECK_PICTURES
} from "../../constant/Apipath";
import { Postrequestcall } from "../../request/Postrequest";

/**
 * ====================================================================
 * Client_InventoryCheckQuestionsForms APIs
 * ====================================================================
 */

/**
 * 1. Fetch Client Inventory Check Questions Forms
 * @param {Object} params
 * @param {number} params.userId
 * @param {number} [params.pageNr=1]
 * @param {number} [params.nrOfRecPerPage=20]
 * @param {string} [params.fullSearch=""]
 * @param {Array}  [params.searchList=[]]
 * @param {Array}  [params.sortList=[]]
 * @param {string} [params.token=""]
 */
export const fetchClientInventoryCheckQuestionsForms = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 20,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
    payload,
    token
  );
};

/**
 * 2. Fetch Client Inventory Check Questions Forms 2
 */
export const fetchClientInventoryCheckQuestionsForms2 = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 50,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId || 1),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  let res = await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS_2,
    payload,
    token
  );

  if (!res || res.status >= 400) {
    res = await Postrequestcall(
      FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
      payload,
      token
    );
  }

  return res;
};

/**
 * 3. Save Client Inventory Check Questions Forms
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.saveList - [{ Id, FormName, FormDescription, ModifiedBy }]
 * @param {string} [params.token=""]
 */
export const saveClientInventoryCheckQuestionsForms = async ({
  userId,
  saveList = [],
  returnRecordId = true,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SaveList: saveList.map((item) => ({
      Id: Number(item.Id || 0),
      FormName: item.FormName || "",
      FormDescription: item.FormDescription || "",
      ModifiedBy: Number(item.ModifiedBy || userId)
    }))
  };

  return await Postrequestcall(
    SAVE_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
    payload,
    token
  );
};

/**
 * 4. Delete Client Inventory Check Questions Forms
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.deleteList - [{ Id }]
 * @param {boolean} [params.softDelete=true]
 * @param {string} [params.token=""]
 */
export const deleteClientInventoryCheckQuestionsForms = async ({
  userId,
  deleteList = [],
  softDelete = true,
  returnRecordId = false,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SoftDelete: softDelete,
    DeleteList: deleteList.map((item) => ({
      Id: Number(typeof item === "object" ? item.Id : item)
    }))
  };

  return await Postrequestcall(
    DELETE_CLIENT_INVENTORY_CHECK_QUESTIONS_FORMS,
    payload,
    token
  );
};

/**
 * ====================================================================
 * Client_InventoryCheckQuestions APIs
 * ====================================================================
 */

/**
 * 1. Fetch Client Inventory Check Questions
 */
export const fetchClientInventoryCheckQuestions = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 50,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "OrderId", Direction: "ASC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS,
    payload,
    token
  );
};

/**
 * 2. Fetch Client Inventory Check Questions 2
 */
export const fetchClientInventoryCheckQuestions2 = async ({
  userId,
  formId,
  pageNr = 1,
  nrOfRecPerPage = 100,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "OrderId", Direction: "ASC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const combinedSearchList = [...searchList];
  if (formId !== undefined && formId !== null && formId !== "") {
    if (!combinedSearchList.some((s) => s.FormId !== undefined || s.formId !== undefined)) {
      combinedSearchList.push({ FormId: Number(formId), formId: Number(formId) });
    }
  }

  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId || 1),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: combinedSearchList,
    SortList: sortList
  };

  let res = await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS_2,
    payload,
    token
  );

  if (!res || res.status >= 400) {
    res = await Postrequestcall(
      FETCH_CLIENT_INVENTORY_CHECK_QUESTIONS,
      payload,
      token
    );
  }

  return res;
};

/**
 * 3. Save Client Inventory Check Questions
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.saveList - [{ Id, QuestionTitle, QuestionSubTitle, QuestionCode, OrderId, QuestionField, FormId, ModifiedBy }]
 */
export const saveClientInventoryCheckQuestions = async ({
  userId,
  saveList = [],
  returnRecordId = true,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SaveList: saveList.map((item, idx) => ({
      Id: Number(item.Id || 0),
      QuestionTitle: item.QuestionTitle || "",
      QuestionSubTitle: item.QuestionSubTitle || "",
      QuestionCode: item.QuestionCode || "",
      OrderId: Number(item.OrderId !== undefined ? item.OrderId : idx + 1),
      QuestionField: item.QuestionField || "text",
      FormId: Number(item.FormId || 1),
      ModifiedBy: Number(item.ModifiedBy || userId)
    }))
  };

  return await Postrequestcall(
    SAVE_CLIENT_INVENTORY_CHECK_QUESTIONS,
    payload,
    token
  );
};

/**
 * 4. Delete Client Inventory Check Questions
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.deleteList - [{ Id }]
 */
export const deleteClientInventoryCheckQuestions = async ({
  userId,
  deleteList = [],
  softDelete = true,
  returnRecordId = false,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SoftDelete: softDelete,
    DeleteList: deleteList.map((item) => ({
      Id: Number(typeof item === "object" ? item.Id : item)
    }))
  };

  return await Postrequestcall(
    DELETE_CLIENT_INVENTORY_CHECK_QUESTIONS,
    payload,
    token
  );
};

/**
 * ====================================================================
 * Client_InventoryFormResponses APIs
 * ====================================================================
 */

/**
 * 1. Fetch Client Inventory Form Responses
 */
export const fetchClientInventoryFormResponses = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 20,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_FORM_RESPONSES,
    payload,
    token
  );
};

/**
 * 2. Fetch Client Inventory Form Responses 2
 */
export const fetchClientInventoryFormResponses2 = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 50,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_FORM_RESPONSES_2,
    payload,
    token
  );
};

/**
 * 3. Save Client Inventory Form Responses
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.saveList - [{ Id, FormId, ClientId, ClientEmployeeId, AssetId, ModifiedBy }]
 */
export const saveClientInventoryFormResponses = async ({
  userId,
  saveList = [],
  returnRecordId = true,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SaveList: saveList.map((item) => ({
      Id: Number(item.Id ?? item.id ?? 0),
      FormId: Number(item.FormId ?? item.form_id ?? 1),
      ClientId: Number(item.ClientId ?? item.client_id ?? 0),
      ClientEmployeeId: Number(item.ClientEmployeeId ?? item.client_empy_id ?? item.ClientEmpyId ?? 0),
      AssetId: Number(item.AssetId ?? item.asset_id ?? item.FixedAssetId ?? item.fixed_asset_id ?? 0),
      Note: item.Note ?? item.note ?? "",
      ModifiedBy: Number(item.ModifiedBy ?? item.modified_by ?? userId)
    }))
  };

  return await Postrequestcall(
    SAVE_CLIENT_INVENTORY_FORM_RESPONSES,
    payload,
    token
  );
};

/**
 * 4. Delete Client Inventory Form Responses
 */
export const deleteClientInventoryFormResponses = async ({
  userId,
  deleteList = [],
  softDelete = true,
  returnRecordId = false,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SoftDelete: softDelete,
    DeleteList: deleteList.map((item) => ({
      Id: Number(typeof item === "object" ? item.Id : item)
    }))
  };

  return await Postrequestcall(
    DELETE_CLIENT_INVENTORY_FORM_RESPONSES,
    payload,
    token
  );
};

/**
 * ====================================================================
 * Client_InventoryCheckAnswers APIs
 * ====================================================================
 */

/**
 * 1. Fetch Client Inventory Check Answers
 */
export const fetchClientInventoryCheckAnswers = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 20,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_ANSWERS,
    payload,
    token
  );
};

/**
 * 2. Fetch Client Inventory Check Answers 2
 */
export const fetchClientInventoryCheckAnswers2 = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 50,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_ANSWERS_2,
    payload,
    token
  );
};

/**
 * 3. Save Client Inventory Check Answers
 * @param {Object} params
 * @param {number} params.userId
 * @param {Array<Object>} params.saveList - [{ Id, ClientId, ClientEmployeeId, QuestionId, ExpectedValue, ExpectedValueType, CorrectionNote, CorrectedValue, CorrectedValueType, FormResponseId, ModifiedBy }]
 */
export const saveClientInventoryCheckAnswers = async ({
  userId,
  saveList = [],
  returnRecordId = true,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SaveList: saveList.map((item) => ({
      Id: Number(item.Id ?? item.id ?? 0),
      ClientId: Number(item.ClientId ?? item.client_id ?? 0),
      ClientEmployeeId: Number(item.ClientEmployeeId ?? item.client_empy_id ?? item.ClientEmpyId ?? 0),
      QuestionId: Number(item.QuestionId ?? item.question_id ?? 0),
      ExpectedValue: String(item.ExpectedValue ?? item.expected_value ?? ""),
      ExpectedValueType: String(item.ExpectedValueType ?? item.expected_value_type ?? ""),
      CorrectionNote: String(item.CorrectionNote ?? item.correction_note ?? ""),
      CorrectedValue: String(item.CorrectedValue ?? item.corrected_value ?? item.expcted_value ?? ""),
      CorrectedValueType: String(item.CorrectedValueType ?? item.corrected_value_type ?? ""),
      FormResponseId: Number(item.FormResponseId ?? item.form_response_id ?? 0),
      ModifiedBy: Number(item.ModifiedBy ?? item.modified_by ?? userId)
    }))
  };

  return await Postrequestcall(
    SAVE_CLIENT_INVENTORY_CHECK_ANSWERS,
    payload,
    token
  );
};

/**
 * 4. Delete Client Inventory Check Answers
 */
export const deleteClientInventoryCheckAnswers = async ({
  userId,
  deleteList = [],
  softDelete = true,
  returnRecordId = false,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SoftDelete: softDelete,
    DeleteList: deleteList.map((item) => ({
      Id: Number(typeof item === "object" ? item.Id : item)
    }))
  };

  return await Postrequestcall(
    DELETE_CLIENT_INVENTORY_CHECK_ANSWERS,
    payload,
    token
  );
};

/**
 * ====================================================================
 * Client_InventoryCheckPictures APIs
 * ====================================================================
 */

/**
 * 1. Fetch Client Inventory Check Pictures
 */
export const fetchClientInventoryCheckPictures = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 20,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_PICTURES,
    payload,
    token
  );
};

/**
 * 2. Fetch Client Inventory Check Pictures 2
 */
export const fetchClientInventoryCheckPictures2 = async ({
  userId,
  pageNr = 1,
  nrOfRecPerPage = 50,
  fullSearch = "",
  searchList = [],
  sortList = [{ FieldName: "Id", Direction: "DESC" }],
  typeOfObjectReturned = "",
  fetchAllowedRecordsOnly = false,
  includeRecordNr = "true",
  token
}) => {
  const payload = {
    PageNr: pageNr,
    NrOfRecPerPage: nrOfRecPerPage,
    FullSearch: fullSearch,
    UserId: Number(userId),
    IncludeRecordNr: includeRecordNr,
    TypeOfObjectReturned: typeOfObjectReturned,
    FetchAllowedRecordsOnly: fetchAllowedRecordsOnly,
    SearchList: searchList,
    SortList: sortList
  };

  return await Postrequestcall(
    FETCH_CLIENT_INVENTORY_CHECK_PICTURES_2,
    payload,
    token
  );
};

/**
 * 3. Save Client Inventory Check Pictures
 * (multipart/form-data POST)
 * @param {Object} params
 * @param {number} [params.id=0]
 * @param {number} params.formId
 * @param {number} params.formResponseId
 * @param {number} params.clientId
 * @param {number} params.clientEmployeeId
 * @param {File|Blob} params.imageUrl - File binary
 * @param {number} params.modifiedBy
 * @param {string} [params.token=""]
 */
export const saveClientInventoryCheckPictures = async ({
  id = 0,
  formId,
  formResponseId,
  clientId,
  clientEmployeeId,
  imageUrl,
  modifiedBy,
  token
}) => {
  const formData = new FormData();
  formData.append("Id", Number(id || 0));
  formData.append("FormId", Number(formId || 0));
  formData.append("FormResponseId", Number(formResponseId || 0));
  formData.append("ClientId", Number(clientId || 0));
  formData.append("ClientEmployeeId", Number(clientEmployeeId || 0));
  formData.append("ModifiedBy", Number(modifiedBy || 1));

  if (imageUrl) {
    if (typeof imageUrl === "string" && imageUrl.startsWith("data:")) {
      // Convert base64 data URL to Blob
      const arr = imageUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const fileBlob = new Blob([u8arr], { type: mime });
      formData.append("ImageUrl", fileBlob, "inventory_check_photo.jpg");
    } else {
      formData.append("ImageUrl", imageUrl);
    }
  }

  return await Postrequestcall(
    SAVE_CLIENT_INVENTORY_CHECK_PICTURES,
    formData,
    token,
    true // is formData flag
  );
};

/**
 * 4. Delete Client Inventory Check Pictures
 */
export const deleteClientInventoryCheckPictures = async ({
  userId,
  deleteList = [],
  softDelete = true,
  returnRecordId = false,
  returnRecordError = true,
  token
}) => {
  const payload = {
    UserId: Number(userId),
    ReturnRecordId: returnRecordId,
    ReturnRecordError: returnRecordError,
    SoftDelete: softDelete,
    DeleteList: deleteList.map((item) => ({
      Id: Number(typeof item === "object" ? item.Id : item)
    }))
  };

  return await Postrequestcall(
    DELETE_CLIENT_INVENTORY_CHECK_PICTURES,
    payload,
    token
  );
};
